import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { EmptyMessageView, MiActivityLog } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { IssueList } from "../../IssueList/IssueList";
import { Closingout } from "../Issues/Closingout/Closingout";
import { useAttemptHistory } from "./useAttemptHistoryViewModel";

export const AttemptHistory = ({
  open,
  users = [],
  assignmentId,
  currentAttemptId,
  stateManager,
}) => {
  const { attemptList, getAttempts, getAttemptDetails } = useAttemptHistory({
    stateManager,
  });
  const { classes } = useStyles();
  const [currentActivity, setCurrentActivity] = useState(null);
  const [issueIndex, setIssueIndex] = useState(0);

  const handleActivityChange = async (activity) => {
    setIssueIndex(0);
    const attemptDetails = await getAttemptDetails(activity.id);

    if (attemptDetails) {
      setCurrentActivity(attemptDetails);
    }
  };

  const handleBack = () => setCurrentActivity(null);

  useEffect(() => {
    if (assignmentId && open) {
      getAttempts({ assignmentId });
    }
  }, [open, assignmentId, currentAttemptId]);

  const renderContent = () => {
    if (currentActivity) {
      return (
        <Closingout
          readOnly
          users={users}
          attempt={currentActivity}
          issueIndex={issueIndex}
          setIssueIndex={setIssueIndex}
          onCancel={handleBack}
        />
      );
    }

    if (attemptList.length === 0) {
      return (
        <EmptyMessageView
          title="No History"
          subtitle="No attempt history has been collected for this assignment yet."
        />
      );
    }

    return (
      <MiActivityLog
        activities={attemptList}
        dateFields={["statusModifiedOn", "modifiedOn"]}
        renderDetail={(activity) => (
          <Box className={classes.attempt}>
            <IssueList
              readOnly
              testId={`issue-list-${activity.id}`}
              attempt={activity}
              highlight={currentAttemptId === activity.id}
              onViewClick={() => handleActivityChange(activity)}
            />
          </Box>
        )}
      />
    );
  };

  return <Box className={classes.container}>{renderContent()}</Box>;
};

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  attempt: {
    padding: theme.spacing(1, 0, 1, 2),
  },
}));
